import dayjs from "dayjs";

export const campaignTelFortuneIds =
  dayjs().month() === 2
    ? [
        9, 490, 221, 19, 546, 391, 1797, 205, 1675, 247, 2108, 291, 448, 1926,
        395, 1311, 522, 1046, 1123, 854, 2166, 981, 1126, 1604, 1137, 2164,
        1200, 1253, 1274, 1409, 1556, 1576, 2398, 1736, 1920, 2061, 1896, 2009,
        1939, 1994, 2069, 2154, 2160, 2318, 2291, 2363,
      ]
    : [
        5, 195, 9, 490, 221, 19, 546, 219, 2107, 205, 1675, 247, 2108, 291, 448,
        1926, 395, 1311, 522, 1046, 1123, 854, 981, 1126, 1604, 1137, 2164,
        1200, 1253, 1274, 1409, 1556, 1576, 2398, 1736, 1853, 2061, 1896, 1939,
        1994, 2069, 2160, 2318, 2291, 2317, 2363, 2372, 2402,
      ];
